import { render } from "./Certs.vue?vue&type=template&id=42606972"
import script from "./Certs.vue?vue&type=script&lang=ts"
export * from "./Certs.vue?vue&type=script&lang=ts"
script.render = render

export default script